import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import WithdrawalStep2SeuContainer from 'pages/Withdrawal/partials/step2/SEU/WithdrawalStep2Seu.container';
import { WithdrawalMode } from 'services/withdrawal/withdrawal.config';
import { z } from 'zod';

const withdrawalStep2SearchSchema = z.object({
  formId: z.string().optional(),
  amount: z.number().optional(),
  depId: z.enum(WithdrawalMode),
  credentialUpdatable: z.boolean().optional(),
  credentialStatus: z.string().optional(),
  credential: z.string().optional(),
});

export const Route = createFileRoute('/_auth/withdrawal/step2')({
  component: WithdrawalStep2SeuContainer,
  validateSearch: zodValidator(withdrawalStep2SearchSchema),
});
